<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRaiseHand_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M20.139 9.575a1.171 1.171 0 0 0-1.444.835l-.94 3.46-1.13-.318 1.877-6.924a1.201 1.201 0 0 0-.818-1.473 1.171 1.171 0 0 0-1.444.835l-1.878 6.923-1.131-.319 2.191-8.077a1.2 1.2 0 0 0-.818-1.473 1.171 1.171 0 0 0-1.444.835l-2.19 8.075-1.132-.32 1.878-6.922a1.2 1.2 0 0 0-.817-1.474 1.17 1.17 0 0 0-1.444.835c-.173.638-2.47 9.1-2.607 9.609-.138.509-.806.51-.92-.004-.091-.4-.372-1.898-.57-2.972a1.192 1.192 0 0 0-1.35-.973A1.2 1.2 0 0 0 3 10.933c.004.918.019 2.287.068 3.43.192 4.456 4.498 6.516 6.586 7.106 2.575.727 5.062.812 6.94-.41 1.292-.84 2.314-2.46 2.805-4.268l1.558-5.743a1.2 1.2 0 0 0-.818-1.473Z"
    />
</svg>
